import { observer } from "mobx-react-lite";
import React, { RefObject } from "react";
import { AColumn } from "src/components/tables/AsyncTable";
import { onTableParamsChange } from "src/components/tables/AsyncTable/onTableParamsChange";
import { TableStore } from "src/components/tables/TableStore";
import { TableSortingButtonSdt } from "src/pages/EntityFiltersPage/AsyncTableView";
import { ResizerStd } from "src/pages/EntityFiltersPage/AsyncTableView/ResizerStd";
import { classNames } from "src/common/classNames";
import { getColumnWidthStyles } from "../getColumnWidths";
import styles from "./ATVHeaderStd.module.less";

const minColumnWidth = 72;

export type PropsATVHeaderCellStd<TRow extends {}, TFilters extends {}> = {
  store: TableStore<TRow, TFilters>;
  column: AColumn<TRow>;
  refs: Record<string, RefObject<HTMLDivElement>>;
};

export const ATVHeaderCellStd = observer(
  <TRow extends {}, TFilters extends {}>({
    store,
    column,
    refs,
  }: PropsATVHeaderCellStd<TRow, TFilters>) => {
    const getColumnHeader = () => {
      const width = store.columnWidths?.[column.key];
      if (width && typeof width === "number") {
        return width > minColumnWidth ? (
          column.title
        ) : (
          <span style={{ whiteSpace: "nowrap" }}>...</span>
        );
      }
      return column.title;
    };
    const sorted = store.sort === column.key && !!store.sortOrder;
    return (
      <div
        ref={refs[column.key]}
        className={classNames([
          styles.headerItem,
          [sorted, styles.headerItemSorted],
        ])}
        key={column.key}
        style={getColumnWidthStyles(store.columnWidths, column.key)}
      >
        {/* eslint-disable-next-line jsx-a11y/no-static-element-interactions */}
        <div
          className={styles.columnHeaderContent}
          onMouseDown={(e) => e.stopPropagation()}
        >
          <TableSortingButtonSdt
            header={getColumnHeader()}
            column={column}
            onChange={(sorter) =>
              onTableParamsChange(
                store,
                { current: store.page, pageSize: store.pageSize },
                sorter,
              )
            }
          />
        </div>
        <ResizerStd
          column={column}
          store={store}
          containerRef={refs[column.key]}
          minWidth={minColumnWidth}
        />
      </div>
    );
  },
);
